import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-item-cnt"
};
const _hoisted_2 = {
  class: "cnt-inner-border"
};
const _hoisted_3 = {
  class: "icon"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "extra"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "nav-item",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.handleClick && $setup.handleClick(...args))
  }, [_createElementVNode("i", _hoisted_3, [_renderSlot(_ctx.$slots, "icon", {}, () => [(_openBlock(), _createBlock(_resolveDynamicComponent($setup.iconComp)))])]), _createElementVNode("span", _hoisted_4, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString($props.label), 1)])]), _createElementVNode("span", _hoisted_5, [_renderSlot(_ctx.$slots, "extra", {}, () => [_createTextVNode(_toDisplayString($props.extra), 1)])])])])]);
}